import {
	FETCH_GRILLES_POLICE_BEGIN,
	FETCH_GRILLES_POLICE_ERROR,
	FETCH_GRILLES_POLICE_SUCCESS,
	POST_GRILLE_POLICE_BEGIN,
	POST_GRILLE_POLICE_ERROR,
	POST_GRILLE_POLICE_RESET,
	POST_GRILLE_POLICE_SUCCESS,
} from "../actions/policeTarifsActions"

// Grille tarifaire police versionnée (GE-8) — /configuration → Dépannage →
// Tarifs police. `grilles` = liste fraîche renvoyée par chaque mutation.
const initialState = {
	grilles: [],
	fetchGrilles: { loading: false, error: false },
	postGrille: { saving: false, saved: false, error: false },
}

export default function policeTarifsReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_GRILLES_POLICE_BEGIN:
			return { ...state, fetchGrilles: { loading: true, error: false } }
		case FETCH_GRILLES_POLICE_SUCCESS:
			return {
				...state,
				grilles: action.payload.grilles,
				fetchGrilles: { loading: false, error: false },
			}
		case FETCH_GRILLES_POLICE_ERROR:
			return {
				...state,
				fetchGrilles: { loading: false, error: action.payload.error },
			}
		case POST_GRILLE_POLICE_BEGIN:
			return {
				...state,
				postGrille: { saving: true, saved: false, error: false },
			}
		case POST_GRILLE_POLICE_SUCCESS:
			return {
				...state,
				postGrille: { saving: false, saved: true, error: false },
			}
		case POST_GRILLE_POLICE_ERROR:
			return {
				...state,
				postGrille: {
					saving: false,
					saved: false,
					error: action.payload.error,
				},
			}
		case POST_GRILLE_POLICE_RESET:
			return { ...state, postGrille: initialState.postGrille }
		default:
			return state
	}
}
